export default __webpack_public_path__ + "static/media/pLoading.bb056329.gif";